export const PAGE_SIZES = {
  pageSizes: [
    {
      value: 15,
      display: '15'
    },
    {
      value: 30,
      display: '30'
    },
    {
      value: 50,
      display: '50'
    },
    {
      value: 100,
      display: '100'
    },
    {
      value: 500,
      display: '500'
    }
  ],
  spanPages: 2
};



// WEBPACK FOOTER //
// E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/utils/index.ts